import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

interface MetricTileProps {
  icon: ReactNode
  label: string
  value: string
  hint?: string
  className?: string
}

export function MetricTile({ icon, label, value, hint, className }: MetricTileProps) {
  return (
    <div className={cn("flex items-start gap-3 rounded-md bg-muted/40 p-3", className)}>
      <div className="mt-0.5 flex size-5 shrink-0 items-center justify-center">{icon}</div>
      <div className="flex min-w-0 flex-col">
        <span className="text-xs text-muted-foreground">{label}</span>
        <span className="truncate text-xl font-medium tabular-nums">{value}</span>
        {hint && <span className="mt-0.5 text-xs text-muted-foreground">{hint}</span>}
      </div>
    </div>
  )
}
